/** Compliance + Goals + Analytics vocabularies (mirror backend enums). */
export const LICENSE_TYPES = [
  { value: "salesperson", label: "Salesperson" },
  { value: "broker", label: "Broker" },
  { value: "broker_associate", label: "Broker Associate" },
  { value: "other", label: "Other" },
];

export const COMPLIANCE_DISCLAIMER =
  "AgentHQ helps you organize licensing, education, and renewal information you provide. Requirements vary by jurisdiction. Verify current requirements with the applicable licensing authority.";

export const GOAL_TYPES = [
  { value: "income", label: "Income", money: true },
  { value: "sales_volume", label: "Sales Volume", money: true },
  { value: "transactions", label: "Transactions", money: false },
  { value: "listings", label: "Listings", money: false },
  { value: "leads", label: "Leads", money: false },
];

export const GOAL_PERIODS = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "annual", label: "Annual" },
  { value: "custom", label: "Custom" },
];

export const ANALYTICS_RANGES = [
  { value: "this_month", label: "This month" },
  { value: "this_quarter", label: "This quarter" },
  { value: "ytd", label: "Year to date" },
  { value: "last_year", label: "Last year" },
  { value: "custom", label: "Custom range" },
];

export const goalTypeLabel = (v) => GOAL_TYPES.find((g) => g.value === v)?.label || v || "—";
export const isMoneyGoal = (v) => !!GOAL_TYPES.find((g) => g.value === v)?.money;

export const statusColor = (s) => ({
  active: "bg-emerald-100 text-emerald-800", complete: "bg-emerald-100 text-emerald-800",
  expiring: "bg-amber-100 text-amber-800", in_progress: "bg-blue-100 text-blue-800",
  expired: "bg-red-100 text-red-800", overdue: "bg-red-100 text-red-800",
  inactive: "bg-secondary text-muted-foreground", not_started: "bg-secondary text-muted-foreground",
}[s] || "bg-secondary text-muted-foreground");

export const paceColor = (p) => ({
  achieved: "text-emerald-600", ahead: "text-emerald-600", on_track: "text-brand-navy",
  behind: "text-amber-600", missed: "text-red-600",
}[p] || "text-muted-foreground");
